(function () {
  'use strict';

  /* Guard: scripts.liquid loads this globally as type="module"; sections also
     load it with defer. Without this guard, event listeners register twice,
     causing double cart-add on every click. */
  if (window.__bkcProductCardInit) return;
  window.__bkcProductCardInit = true;

  /* ── Variation overlay ── */
  function openOverlay(productId) {
    var overlay = document.getElementById('var-overlay-' + productId);
    if (overlay) overlay.classList.add('open');
  }

  function closeOverlay(productId) {
    var overlay = document.getElementById('var-overlay-' + productId);
    if (overlay) overlay.classList.remove('open');
  }

  /* ── Update overlay price when variant changes ── */
  function handleVariantChange(select) {
    var productId = select.dataset.productId;
    var priceEl   = document.getElementById('overlay-price-' + productId);
    var addBtn    = document.querySelector('[data-overlay-add="' + productId + '"]');
    var option    = select.options[select.selectedIndex];

    if (priceEl) priceEl.textContent     = option.dataset.price;
    if (addBtn)  addBtn.dataset.variantId = select.value;
  }

  /* ── Ajax: add to cart + open side cart ── */
  /* Delegates to the single shared window.bkcAddToCart defined in bkc-header.js */
  function addToCart(variantId, btn) {
    if (!variantId) return;
    if (typeof window.bkcAddToCart !== 'function') {
      console.error('[BKC] window.bkcAddToCart not defined — bkc-header.js may not have loaded correctly.');
      return;
    }
    window.bkcAddToCart(variantId, 1, btn);
  }

  /* ── Event delegation ── */
  document.addEventListener('click', function (e) {
    var t = e.target;

    /* All overlay interaction buttons live inside an <a class="prod-card">.
       preventDefault() is required on every branch to stop the parent anchor
       from also navigating to the product page. */

    var openBtn = t.closest('[data-open-overlay]');
    if (openBtn) { e.preventDefault(); openOverlay(openBtn.dataset.openOverlay); return; }

    var closeBtn = t.closest('[data-close-overlay]');
    if (closeBtn) { e.preventDefault(); closeOverlay(closeBtn.dataset.closeOverlay); return; }

    var clearBtn = t.closest('[data-clear-overlay]');
    if (clearBtn) {
      e.preventDefault();
      var pid = clearBtn.dataset.clearOverlay;
      var sel = document.querySelector('.overlay-variant-select[data-product-id="' + pid + '"]');
      if (sel) { sel.selectedIndex = 0; handleVariantChange(sel); }
      return;
    }

    var singleAddBtn = t.closest('[data-add-to-cart]');
    if (singleAddBtn) { e.preventDefault(); addToCart(singleAddBtn.dataset.addToCart, singleAddBtn); return; }

    var overlayAddBtn = t.closest('[data-overlay-add]');
    if (overlayAddBtn) {
      e.preventDefault();
      var vid = overlayAddBtn.dataset.variantId;
      if (vid) { addToCart(vid, overlayAddBtn); closeOverlay(overlayAddBtn.dataset.overlayAdd); }
      return;
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('overlay-variant-select')) handleVariantChange(e.target);
  });

})();
